// extracted by mini-css-extract-plugin
module.exports = {"input":"InputNum_input__lc8R5"};